import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { PasswordStrengthValidator } from 'src/app/Product/password-strength.validators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private loginService: LoginService,
    private alertService: AlertService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  submitted = true;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  hide = true;
  hideNew=true;
  hideConfirmNew = true;

  forgotForm: FormGroup = new FormGroup(
    {
      userId: new FormControl(this.authService.getRegistredUserDetails().userId, [Validators.required]),
      username: new FormControl(this.authService.getRegistredUserDetails().firstName),
      email: new FormControl(this.authService.getRegistredUserDetails().email, [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      oldPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        PasswordStrengthValidator
      ]),
      newPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        PasswordStrengthValidator
      ]),
      confirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        PasswordStrengthValidator
      ])
    }
  )

  onSubmit() {
    this.submitted = true;
    const token = this.authService.getToken();
    if (this.forgotForm.valid) {
      if (this.forgotForm.value.newPassword == this.forgotForm.value.confirmPassword) {
        this.loginService.changePassword(this.forgotForm.value, token)
          .subscribe((response) => {
            console.log(response);
            this.alertService.success('Success!! Password Changed SuccessFully.', this.options);
            setTimeout(() => {
              this.router.navigate(['/signin'])
            }, 2000);
          }, (err) => {
            console.log(err);
            this.alertService.error(err.error.errors.Messages[0], this.options);
          })
      } else {
        console.log("New password and confirm password should be match!");
        this.alertService.error('Error :( New password and confirm password should be match!', this.options)
      }
    } else {
      console.log("Enter valid data");
      this.alertService.error('Error :( Please Enter Valid Details !', this.options)
    }

  }

  get forms() {
    return this.forgotForm.controls;
  }

}



